import React, { createContext, useContext, useEffect, useState } from "react";
import { useGetApiRequests } from "../../../common/CommonExport";
import axios from "axios";
import { ApplyLeaveContextProps, EmailAnnouncement, LeaveOption, LeaveBankProps, LeaveListProps, ReduxState, AnnouncementPayload, LeaveDate, LeaveRequestPayload, LeaveRequestResponse } from './ApplyLeaveContext.types';
import { Dayjs } from 'dayjs';
import { useSelector } from "react-redux";
import PopupModal from "../../employee/employee-details/employee-profile/modal/PopupModal";
import { useDispatch } from "react-redux";
import { setPermissionCount, setPermissionTimingInString, setOnDutyCount } from "../../../redux/slices/leaveReportPayloadSlice";
import { getCurrentMonthObjects } from "./ApplyLeaveContextHelper";

const ApplyLeaveContext = createContext<ApplyLeaveContextProps | undefined>(undefined);

export const ApplyLeaveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userId = useSelector((state: ReduxState) => state?.userId?.id);
  const orgId = useSelector((state: ReduxState) => state?.organisationId?.id);
  const getLeaveList = useGetApiRequests("getUserLeaveList", "POST");
  const applyLeaveRequest = useGetApiRequests('applyLeaveRequest', 'POST');
  const getAnnouncementsList = useGetApiRequests("employeeFilterAnnouncement", "POST");
  const getLeaveRequestList = useGetApiRequests("leaveRequestList", "GET");

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [leaveList, setLeaveList] = useState<LeaveListProps[]>([]);
  const [leaveBankData, setLeaveBankData] = useState<LeaveBankProps[]>([]);
  const [leaveOptions, setLeaveOptions] = useState<LeaveOption[]>([]);
  const [permissionOption, setPermissionOption] = useState<LeaveOption[]>([]);
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)
  const [showDate, setShowDate] = useState(false)
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [isCompletedPermission, setIsCompletedPermission] = useState<boolean>(false)
  const [formReset, setFormReset] = useState<() => void>(() => () => { });

  const [announcementList, setAnnouncementList] = useState<EmailAnnouncement[] | undefined>();
  const [loader, setLoader] = useState(true)
  const [leaveLoading, setLeaveLoading] = useState(false);

  const [initialValues, setInitialValues] = useState<{
    leaveType: string;
    leaveDate: LeaveDate;
    leaveReason: string;
    leavePolicyId: string | number;
    leaveDuration: string;
    leaveStatus: string;
    permissionStartTime: string | Dayjs;
    permissionEndTime: string | Dayjs;
    halfDayLeave: boolean;
  }>({
    leaveType: "1",
    leaveDate: {
      dateRangeSelected: false,
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0))
    },
    // leaveDate: [dayjs(), dayjs()]
    // leaveDate: null,
    leaveReason: '',
    leavePolicyId: '',
    leaveDuration: '',
    leaveStatus: '',
    permissionStartTime: "",
    permissionEndTime: "",
    halfDayLeave: false,
  });


  const handleOpenModal = () => {
    setModalOpen(true);
  }
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    init()
  }, [])
  const init = () => {
    dispatch(setPermissionTimingInString({}))
    setShowDate(false)
    getUsersList()
    getLeaveBankData()
  }

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const getLeaveBankData = async () => {
    setLoader(true)
    const employeeId = userId;
    const organisationId = orgId;
    try {
      const pathParams = {
        employeeId: `${employeeId}/leave-request/list?organisationId=${organisationId}`
      };

      const response = await getLeaveRequestList('', {}, pathParams);

      if (axios.isAxiosError(response)) {
        throw new Error(response.message);
      }



      if (response?.data) {
        setLeaveBankData(response?.data?.data?.employeeLeaveBankDtoList)
        const storeLeaveBankData = response?.data?.data?.employeeLeaveBankDtoList
        const permissionBalance = response?.data?.data?.employeeLeaveBankDtoList
          .filter((item: LeaveBankProps) => item.policyName === 'Permission')
          .map((item: LeaveBankProps) => item.balance);
        dispatch(setPermissionCount(permissionBalance));

        const onDutyCount = response?.data?.data?.employeeLeaveBankDtoList
          .filter((item: LeaveBankProps) => item.policyName === 'On Duty')
          .map((item: LeaveBankProps) => item.balance);
        dispatch(setOnDutyCount(onDutyCount))




        if (Array.isArray(storeLeaveBankData) && storeLeaveBankData.length > 0) {
        }
        if (storeLeaveBankData?.length) {
          handleGenerateLeaveOptions(storeLeaveBankData);
        }
        setTimeout(() => {
          setLoader(false)
        }, 2000)
      }
    } catch (error) {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
      console.error('Error fetching leave requests:', error);
    } finally {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
    }
  };
  const handleGenerateLeaveOptions = (el: LeaveBankProps[]) => {
    const leaveTypes: LeaveOption[] = el?.map((item: LeaveBankProps) => {
      // const trimSpace = item.policyName.replace(/\s+/g, '');
      return {
        value: item.policyName,
        label: `${item.policyName} (${item.balance})`,
        ...item
      };
    });
    const permissionValue = leaveTypes.filter((value: LeaveOption) => value.policyName === "Permission");
    setPermissionOption(permissionValue || []);

    const filterValue = leaveTypes.filter((value: LeaveOption) => {
      if (value.policyName !== "Permission") {
        return value
      }
      return undefined;
    })

    setLeaveOptions(filterValue || []);
  };

  const getUsersList = async (): Promise<void> => {
    const start: number = currentPage - 1 === 0 ? 0 : currentPage - 1;
    try {
      setLoader(true)
      const payload = {
        searchEmployeeLeaveDto: {
          employeeId: userId,
          organisationId: orgId,

        },
        start: start,
        limit: pageSize,
        "sortBy": "employeeLeavePolicyRequestMapId",
        "sortDirection": "DESC"
      };
      const response = await getLeaveList(payload);
      if (axios.isAxiosError(response)) {
        throw new Error(response.message);
      }
      if (response?.data) {
        const data = response?.data?.data;
        let permissionList: LeaveListProps[] = [];
        setCount(response?.data?.totalResults);
        const tempUserList: LeaveListProps[] = data?.map((item: Partial<LeaveListProps>) => {
          const mappedItem: LeaveListProps = {
            duration: item?.duration ?? 0,
            policyName: item?.policyName ?? '-',
            status: item?.status ?? '-',
            startDate: formatDate(item?.startDate ?? '') ?? '-',
            endDate: formatDate(item?.endDate ?? '') ?? '-',
            lopCount: item?.lopCount ?? '-',
            reason: item?.reason ?? '-',
            employeeLeavePolicyRequestMapId: item.employeeLeavePolicyRequestMapId ?? 0,
          };

          if (item?.policyName === "Permission" && item?.status !== "declined") {
            permissionList.push(item as LeaveListProps);
          }
          return mappedItem;
        });

        const completedPermission = getCurrentMonthObjects(permissionList)
        setIsCompletedPermission(completedPermission)
        setLeaveList(tempUserList);
        setTimeout(() => {
          setLoader(false)
        }, 3000)
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Error fetching leave list:", error.response?.data || error.message);
        setLoader(false)
      } else {
        console.error("Unexpected error:", error);
        setLoader(false)
      }
      setLeaveList([]);
    } finally {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
    }
  };



  const getAnnouncements = () => {
    const payload: AnnouncementPayload = {
      searchEmailAnnouncementDto: {
        isActive: true,
        organisationId: orgId,
        status: "SENT",
      },
      start: 0,
      limit: 100,
    };
    getAnnouncementsList(payload)
      .then((response) => {
        if (axios.isAxiosError(response)) {
          throw response;
        }
        setAnnouncementList(response?.data);
      })
      .catch((err) => {
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(err?.message)
        setModalResponse('error')
        setTimeout(() => {
          handleClosePopUpModal();
          setLoader(false);
        }, 1500)
      });
  };

  const handleClosePopUpModal = () => {
    setPopModal(false)
  }

  const errorMessageModal = (response: LeaveRequestResponse | unknown) => {
    setPopModal(true)
    setmodalButtonShow(false)
    const errorResponse = response as LeaveRequestResponse;
    const errorMessage = errorResponse?.response?.data?.message || (response as { message?: string })?.message || 'An error occurred';
    setModalErrMessage(errorMessage)
    setModalResponse('error');
    setShowDate(false)
    formReset()
    setTimeout(() => {
      handleClosePopUpModal();
      setLoader(false);
    }, 3000)
  }

  const submitLeaveRequest = async (payload: LeaveRequestPayload) => {
    setLoader(true);
    setLeaveLoading(true);

    try {
      return applyLeaveRequest(payload) // ✅ return the Promise here
        .then((res: unknown) => {
          const response = res as LeaveRequestResponse;
          if (response.status && [200, 201, 202, 203, 204, 205].includes(response.status)) {
            init();
            setPopModal(true);
            setmodalButtonShow(false);
            setModalErrMessage(response?.data?.message || 'Success');
            setModalResponse("success");

            setTimeout(() => {
              handleClosePopUpModal();
              setLoader(false);
              setLeaveLoading(false);
            }, 1000);
          } else {
            errorMessageModal(response);
          }

          return response; // ✅ now this gets pa
        })
        .catch((err: unknown) => {
          setLeaveLoading(false);
          errorMessageModal(err);
          return err as LeaveRequestResponse;
        });
    } catch (error) {
      setLeaveLoading(false);
      console.error("Error submitting leave request:", error);
      return error as LeaveRequestResponse;
    } finally {
      setTimeout(() => {
        setLeaveLoading(false);
        setLoader(false);
      }, 2000);
    }
  };

  return <ApplyLeaveContext.Provider value={{
    modalOpen, handleOpenModal, handleCloseModal, getUsersList, getAnnouncements, announcementList, leaveList, initialValues,
    setInitialValues, loader, leaveBankData, submitLeaveRequest, leaveOptions, permissionOption, showDate, setShowDate, init, currentPage, setCurrentPage, pageSize, setPageSize, count, setFormReset, isCompletedPermission, leaveLoading,
    setLoader, resetForm: formReset, setResetForm: setFormReset
  }}>{children}
    {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}</ApplyLeaveContext.Provider>;
};

export const useApplyLeave = (): ApplyLeaveContextProps => {
  const context = useContext(ApplyLeaveContext);
  if (!context) {
    throw new Error("useApplyLeave must be used within an ApplyLeaveProvider");
  }
  return context;
};
